import TagList, { Tag } from "core/components/Tag";
import { _t } from "core/language";
import GoToOptionButton from "modules/Ingredients/components/GoToOptionButton";
import type { TIngredient } from "modules/Ingredients/store/types";
import React, { memo, useLayoutEffect, useRef, useState, useEffect, useMemo } from "react";
import RefreshIcon from "../assets/icon/refresh-icon.svg";
import MainNodata from "./NodataComponent";
// import { useMyIngredientRequested } from "modules/Ingredients/hooks/myIngredientRequested";
import { useMyIngredient } from "modules/Ingredients/hooks/myIngredient";
import { useIsAuth } from "modules/Auth/hooks";
import { RouterName } from "core/router";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
// import IconTitle from "../assets/images/icon_section_ingredient.svg";
import IconSectionIngredient from "./icon/IconSectionIngredient";

const IngredientsSection: React.FC = () => {

  const ref = useRef<HTMLDivElement>(null);
  const [tagHeight, setTagHeight] = useState<number>(0);

  useLayoutEffect(() => {
    if(ref.current === null) return;
    const { height } = ref.current.getBoundingClientRect();
    setTagHeight(height);
    console.log(tagHeight,"tagHeight");
  }, []);

  const { ingredients: ingredientsLocal, reload, loading } = useMyIngredient();
  const navigate = useCustomNavigate();
  const ingredients = useMemo(() => {
    function shuffleArray(array: any[]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }

      return array;
    }

    return shuffleArray([...ingredientsLocal]).map((item: TIngredient) => ({
      id: item.id.toString(),
      text: item.name,
      image: item.image,
    }));
  }, [ingredientsLocal]);
  const [selectedIngredients, setSelectedIngredients] = useState<TIngredient[]>(
    []
  );
  const [values, setValues] = useState<string[]>([]);
  const isAuth = useIsAuth();

  const handleChangeTag = (ids: string[], tags: Tag[]) => {
    setValues(ids);
    const convertedIngredients: TIngredient[] = tags.map((tag) => ({
      id: parseInt(tag.id),
      name: tag.text,
      image: tag.image,
      created_at: tag?.created_at,
    }));
    setSelectedIngredients(convertedIngredients);
  };

  useEffect(() => {
    reload();
  }, [])

  const refreshIngredients = () => {
    setValues([]);
    setSelectedIngredients([]);
    reload();
  };

  if (!ingredients) {
    return null;
  }

  // if (!isAuth) return null;
  const handleAddIngredient = () => {
    navigate(RouterName.INGREDIENTS+`?tab=my-ingredient`);
  };

  

  return (
    <section className="relative mb-2.5 font-medium bg-white shadow-sm overflow-x-scroll no-scrollbar mt-[-20px] z-20 rounded-tl-[24px] rounded-tr-[24px]">
      <div className="flex flex-col px-4 py-[20px] pb-8 w-full ">
        <header className="flex items-start gap-5 justify-between">
          <div>
            <h1 className="text-[16px] font-bold flex items-center text-[#111111]">
              {_t("main.my_food_ingredients")}{" "} <div className="ml-1"><IconSectionIngredient  /></div>
            </h1>
            <p className="text-[#777777] text-[12px] font-medium">
              {_t("main.my_food_reason")}
            </p>
          </div>
          {isAuth && ingredients.length > 0 ? (
            <img
              src={RefreshIcon}
              className="mt-1"
              alt=""
              onClick={refreshIngredients}
            />
          ) : (
            ""
          )}
        </header>
        {isAuth && ingredients.length > 0 ? (
          <>
            <nav className="flex gap-2.5 items-center mt-[14px] w-full text-sm text-neutral-500 flex-wrap" ref={ref}>
              <TagList
                options={ingredients}
                loading={loading}
                // expandLimit={6}
                expandLine={2}
                onChange={handleChangeTag}
                value={values}
                activeClasses="bg-[#ffffff] text-[#FF6741] border border-[#FF6741]"
                inactiveClasses="bg-[#ffffff] text-[#999999] border border-[#999999]"
                className="w-full relative"
              />
              <MainNodata
                loading={loading}
                data={ingredients}
                text={_t("main.no_data")}
              />
            </nav>

            <GoToOptionButton
              disabled={values.length === 0}
              type="main"
              text={_t("main.view_recipe")}
              ingredients={selectedIngredients}
            />

            <div
              className="mt-5 text-center"
              onClick={() => {
                navigate(RouterName.INGREDIENTS+`?tab=my-ingredient`);
              }}
            >
              <label
                htmlFor=""
                className="text-[#777777] text-[13px] font-normal border-b border-[#777777]"
              >
                {_t("main.my_ingredient")}
              </label>
            </div>
          </>
        ) : (
          <div
            className="w-full mt-3.5 h-[50px] !bg-[#111111] !text-white rounded-[90px] !border-none !ring-0 px-5 flex items-center justify-center cursor-pointer"
            onClick={handleAddIngredient}
          >
            <label className="text-[14px] font-medium">
              {_t("main.add_ingredient")}
            </label>
          </div>
        )}
      </div>
    </section>
  );
};

export default memo(IngredientsSection);
